import HTTPClient from './http-client';
import { createUrl } from "../utils_functions";
const END_POINT = '/operation';

const options = {
  cache: {
      maxAge: 30 * 60 * 1000,
      exclude: { query: false }
  }
}

const loadOperations = async ({operation_ids}) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  const url = createUrl(END_POINT, {operation_ids});
  return api.get(url, options);
}

export {
    loadOperations,
}
